<template>
  <div class="roles-tab">
    <Button
      v-if="showEditRolesButton"
      buttonColor="darkBlue"
      buttonSize="big"
      buttonText="Добавить роль"
      @click="showRolePopup"
      class="roles-tab__button"
    />
    <SubpanelTable
      :tableColumns="tableColumns"
      :tableData="tableData"
      :height="tableHeight"
      :allowDelete="allowDelete"
      @handleDelete="role => deleteRole(role)"
    />
  </div>
</template>

<script>
import { store } from '@/store';
import Button from 'Elements/Button/Button';
import { mixin, errorMsg } from '@/utils/mixins';
import SubpanelTable from 'Elements/Table/SubpanelTable';
import { MODULE, EVENTBUS_EVENTS } from '@/utils/constants';
import { eventBus } from '@/bus';

export default {
  mixins: [mixin, errorMsg],
  created() {
    eventBus.$on(EVENTBUS_EVENTS.ROLES_EDIT, (success, errorMsg) =>
      this.handleEditRolesEvent(success, errorMsg)
    );
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.ROLES_EDIT);
  },
  computed: {
    tableData() {
      return (
        store.state.subpanels.activeSubpanelData?.user_roles?.data?.List || []
      );
    },
    showEditRolesButton() {
      return store.state.users.userMetadata?.bean?.isRoleAddAllowed || false;
    },
    allowDelete() {
      return (
        !store.state.subpanels.activeSubpanelData.user_roles.data?.title.delete
          .hidden || false
      );
    },
    tableColumns() {
      const columns = store.state.subpanels.activeSubpanelData?.user_roles?.data
        ?.title
        ? {
            ...store.state.subpanels.activeSubpanelData?.user_roles?.data?.title
          }
        : {};
      if (columns.hasOwnProperty('delete')) {
        delete columns.delete;
      }
      return columns || {};
    },
    tableHeight() {
      return (
        49 +
        store.state.subpanels.activeSubpanelData?.user_roles?.data?.List
          .length *
          51
      ).toString();
    }
  },
  methods: {
    handleEditRolesEvent(success, errorMsg = '') {
      if (success) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Роли успешно изменены',
          duration: 15000,
          type: 'success'
        });
        eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, 'user_roles');
      } else {
        this.showNotification({
          offset: 100,
          showClose: true,
          message:
            errorMsg || 'Возникла ошибка при изменении ролей пользователя',
          duration: 15000,
          type: 'error'
        });
      }
    },
    showRolePopup() {
      const intent = {
        module: MODULE.USERS,
        action: 'getRolePopup',
        intentArea: 'CustomPopup',
        intentType: 'create_popup',
        request: {
          url: '/index.php?module=Users&action=getRolePopup',
          request_params: {
            record: this.$route?.params?.id
          }
        }
      };

      // const data = this.sendFormRequestFromIntent(intent);
      store.dispatch('dialog/getPopupData', { item: { intents: [intent] } });
      // console.warn(data);
    },
    async deleteRole(role) {
      try {
        await mixin.methods.sendFormRequestFromIntent(role.delete.intent);
        eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, 'user_roles');
      } catch (e) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Возникла ошибка при удалении роли пользователя',
          duration: 15000,
          type: 'error'
        });
      }
    }
  },
  components: {
    Button,
    SubpanelTable
  }
};
</script>

<style lang="scss" scoped>
.roles-tab {
  display: flex;
  flex-direction: column;
  padding: 16px 24px 24px;
  gap: 16px;

  &__button {
    width: fit-content;
  }
}
</style>
